
import API from '../axios';

// Auth API calls

// Register a new user
export const register = (formData) => API.post('/auth/register', formData);
// Register user (creates user + sends first OTP)
// Login an existing user
export const login = (formData) => API.post('/auth/login', formData);

// Refresh access token using httpOnly cookie
export const refreshToken = () => API.post('/auth/refresh-token');
export const sendOtp = (data) => API.post('/auth/send-otp', data);
export const verifyOtp = (data) => API.post('/auth/verify-otp', data);
export const forgotPassword = (data) => API.post('/auth/forgot-password', data);
export const resetPassword = (data) => API.post('/auth/reset-password', data);
